import { getEnvide } from "services/developer";
// {
//     scope: "Sanmina",
//     stage: "dev",
//   }
export async function mapValueToKey(value, isMES16) {
  if (
    isMES16 &&
    value.scope === "Sanmina" &&
    (value.stage === "DEV" ||
      value.stage === "SQA" ||
      value.stage === "PREVIEW")
  ) {
    value.MES = "MES16";
  }
  const ENVIDE = await getEnvide();
  const filteredArr = Object.entries(ENVIDE).filter(
    ([k, v]) => JSON.stringify(value) === JSON.stringify(v)
  );
  if (filteredArr.length) {
    const filteredObj = Object.fromEntries(filteredArr);
    return Object.keys(filteredObj)[0];
  }
}

export function isAppExist(appDetail) {
  return appDetail && appDetail.AppId;
}
